import React, { useEffect, useState } from "react";
// import axios from "axios";
import { Box } from "./sitemapValidatorStyle";
import { isInIframe } from "../../utils/is-in-iframe";
import { ToolsHeader } from "../components/ToolsHeader";
import axios from "axios";
// import { FaCheck } from "react-icons/fa";
// import { ImCross } from "react-icons/im";

interface ApiResponse {
  success: boolean;
  message: string;
  data: string;
}
interface ValidationResult {
  success: boolean;
  sitemap_url: string;
  character_set: string;
  is_valid: string;
  total_files: number;
  files: string[];
  warnings: string;
  errors: string;
  errors_count: number;
  missing_lastmod_links: string[];
  warnings_count: number;
}

const SitemapValidator: React.FC = () => {
  const [domainLink, setDomainLink] = useState("");
  const [domainInfo, setDomainInfo] = useState<ValidationResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [tabsName, setTabsName] = useState("Success");

  useEffect(() => {
    const height = document.body.scrollHeight;
    window.parent.postMessage({ type: "setHeight", height }, "*");
  }, [tabsName, error, domainInfo]);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setError("");
      setDomainInfo(null);
      let domainHttp = domainLink.trim();
      if (!/^https?:\/\//i.test(domainHttp)) {
        domainHttp = `https://${domainHttp}`;
      }
      if (!validateUrl(domainHttp)) {
        setError("Please enter a valid URL including http:// or https://");
        return;
      }
      setLoading(true);
      const baseUrl = process.env.REACT_APP_BASE_API;
      const response: any = await axios.post<ApiResponse>(
        `${baseUrl}/api/site-map/sitemap-validator`,
        { sitemap_url: domainHttp }
      );
      if (response.status !== 200) {
        setLoading(false);
        return;
      }
      if (response?.data?.success && response?.data) {
        setDomainInfo(response?.data);
        setLoading(false);
        setTabsName("Success");
      } else if (!response?.data?.success) {
        setError("Failed to fetch the content of the sitemap.");
      }
      setLoading(false);
      const height = document.body.scrollHeight;
      window.parent.postMessage({ type: "setHeight", height }, "*");
      return;
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const validateUrl = (url: string): boolean => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  return (
    <Box>
      <div className={`container_domain ${isInIframe && "interDisplay"}`}>
        {!isInIframe && (
          <ToolsHeader
            title="XML Sitemap Validator"
            description={`This tool checks if your XML sitemap is formatted correctly and lists all nested files.`}
          />
        )}
        <form className={`${domainInfo && "url-form"}`}>
          <div className="input-group-box" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', maxWidth: 'min(600px, 90vw)', margin: '0 auto', width: '100%' }}>
            <input
              type="text"
              className="input_checker"
              value={domainLink}
              onChange={(e) => {
                setError("");
                setDomainLink(e.target.value);
              }}
              placeholder="Enter URL (e.g., https://example.com/sitemap.xml)"
              required
              style={{ flex: 1, minWidth: '250px', boxSizing: 'border-box' }}
            />
            <button
              onClick={handleSubmit}
              type="submit"
              disabled={loading}
              className="checker_button"
              style={{ flexShrink: 0, whiteSpace: 'nowrap', minWidth: '100px' }}
            >
              {loading ? "Checking..." : "Check"}
              <span className="spinner hidden"></span>
            </button>
          </div>
          {error && <div className="error-message">{error}</div>}
        </form>
        {domainInfo && (
          <>
            <div
              style={{
                maxHeight: "25rem",
                overflow: "auto",
                border: "1px solid #d1d5db",
                padding: "20px",
                borderRadius: "8px",
                maxWidth: "min(800px, 90vw)",
                width: "100%",
                margin: "20px auto 0",
                boxSizing: 'border-box'
              }}
            >
              <div className="mainTabButton">
                <div
                  className="buttonTabValidator"
                  style={{
                    background: "#8cc540",
                  }}
                  onClick={() => setTabsName("Success")}
                >
                  {`Success (${domainInfo.total_files || 0})`}
                </div>
                <div
                  className="buttonTabValidator"
                  style={{
                    background: "#dc3545",
                  }}
                  onClick={() => setTabsName("Errors")}
                >
                  {`Errors (${domainInfo.errors_count || 0})`}
                </div>
                <div
                  className="buttonTabValidator"
                  style={{
                    background: "#ffc107",
                  }}
                  onClick={() => setTabsName("Warnings")}
                >
                  {`Warnings (${domainInfo.warnings_count || 0})`}
                </div>
              </div>
              {tabsName === "Success" && (
                <div>
                  <div
                    style={{
                      fontWeight: "700",
                      marginTop: "0.5rem",
                      marginBottom: "0.5rem",
                      color: "#8cc540",
                    }}
                  >
                    Success Details
                  </div>
                  <div
                    style={{
                      fontWeight: "700",
                      marginBottom: "0.5rem",
                      wordBreak: "break-all",
                    }}
                  >
                    {"Sitemap URL : "}
                    <span style={{ fontWeight: "400" }}>
                      {domainInfo.sitemap_url || ""}
                    </span>
                  </div>
                  <div
                    style={{
                      fontWeight: "700",
                      marginBottom: "0.5rem",
                      wordBreak: "break-all",
                    }}
                  >
                    {"Character Set : "}
                    <span style={{ fontWeight: "400" }}>
                      {domainInfo.character_set || ""}
                    </span>
                  </div>
                  <div
                    style={{
                      fontWeight: "700",
                      marginBottom: "0.5rem",
                      wordBreak: "break-all",
                    }}
                  >
                    {"Sitemap is valid : "}
                    <span style={{ fontWeight: "400" }}>
                      {domainInfo.is_valid ? "Yes" : "No"}
                    </span>
                  </div>

                  <div>
                    <ul
                      style={{
                        listStyle: "decimal",
                        paddingLeft: "20px",
                        lineHeight: "2",
                        fontWeight: "500",
                      }}
                    >
                      {domainInfo.files.map((link, index) => (
                        <li key={index} style={{ marginBottom: '8px' }}>
                          <a
                            href={link}
                            style={{
                              color: "#0073e6",
                              textDecoration: "none",
                              wordBreak: "break-all",
                            }}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {link}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
              {tabsName === "Errors" && (
                <div>
                  <div
                    style={{
                      fontWeight: "700",
                      marginTop: "0.5rem",
                      marginBottom: "0.5rem",
                      color: "#dc3545",
                    }}
                  >
                    Errors Details
                  </div>
                  <div
                    style={{
                      fontWeight: "700",
                      marginBottom: "0.5rem",
                      wordBreak: "break-all",
                    }}
                  >
                    {"Errors : "}
                    <span style={{ fontWeight: "400" }}>
                      {domainInfo.errors || ""}
                    </span>
                  </div>
                </div>
              )}
              {tabsName === "Warnings" && (
                <div>
                  <div
                    style={{
                      fontWeight: "700",
                      marginTop: "0.5rem",
                      marginBottom: "0.5rem",
                      color: "#ffc107",
                    }}
                  >
                    Warnings Details
                  </div>
                  <div
                    style={{
                      fontWeight: "700",
                      marginBottom: "0.5rem",
                      wordBreak: "break-all",
                    }}
                  >
                    {"Warnings : "}
                    <span style={{ fontWeight: "400" }}>
                      {domainInfo.warnings || ""}
                    </span>
                  </div>
                  <div
                    style={{
                      fontWeight: "700",
                      marginBottom: "0.5rem",
                      wordBreak: "break-all",
                    }}
                  >
                    {"Missing lastmod links count : "}
                    <span style={{ fontWeight: "400" }}>
                      {(domainInfo.missing_lastmod_links || []).length}
                    </span>
                  </div>
                  <div>
                    <ul
                      style={{
                        listStyle: "decimal",
                        paddingLeft: "20px",
                        lineHeight: "2",
                        fontWeight: "500",
                      }}
                    >
                      {domainInfo.missing_lastmod_links.map((link, index) => (
                        <li key={index} style={{ marginBottom: '8px', wordBreak: "break-all" }}>
                          {link}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </Box>
  );
};

export default SitemapValidator;